import { portalConfig } from '../configs/portal';

export const ensureAuthSuccess = (result) => {
    if (result instanceof Error) throw result;
    return result;
};

export const getAllowedRoles = (user) => {
    if (!user?.uuid || !Array.isArray(user.roles)) return [];
    return [...new Map(user.roles.filter((role) =>
        role && portalConfig.allowedRoles.includes(role.name) &&
        role.uuid && role.account?.uuid && !role.disabled
    ).map((role) => [role.uuid, role])).values()];
};

export const getAvailableClinics = (roles) =>
    [...new Map(roles.map((role) => [role.account.uuid, role.account])).values()];

export const accessStorageKey = (userUuid) => `connectedheart:${portalConfig.id}:${userUuid}:access`;

export const readStoredAccess = (userUuid) => {
    try { return JSON.parse(sessionStorage.getItem(accessStorageKey(userUuid))) || null; }
    catch { return null; }
};

export const storeAccess = (userUuid, role) => {
    if (!userUuid) return;
    try {
        if (role) sessionStorage.setItem(accessStorageKey(userUuid), JSON.stringify({
            roleUuid: role.uuid, clinicUuid: role.account.uuid
        }));
        else sessionStorage.removeItem(accessStorageKey(userUuid));
    } catch { /* Selection still works without browser storage. */ }
};

export const resolvePortalAccess = (user, preferred = null) => {
    const roles = getAllowedRoles(user);
    const stored = roles.find((role) =>
        role.uuid === preferred?.roleUuid && role.account.uuid === preferred?.clinicUuid
    );
    const role = stored || (roles.length === 1 ? roles[0] : null);
    return { user, role, status: role ? 'ready' : roles.length ? 'select-access' : 'denied' };
};
